var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notif"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25C19.6274 25 25 19.6274 25 13Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.161 16.7942L18.1028 16.8342C18.0191 16.8734 17.9299 16.8942 17.8465 16.8942H7.97533C7.87368 16.8942 7.76841 16.8631 7.66381 16.7994C7.57203 16.7344 7.49893 16.6449 7.44725 16.5366C7.4036 16.4365 7.39033 16.3295 7.40685 16.2143C7.43234 16.1017 7.48609 16.0007 7.56487 15.9151C8.02371 15.437 8.29556 14.7693 8.47551 14.1026C8.65725 13.4293 8.75785 12.7056 8.84254 12.088C8.84257 12.0877 8.8426 12.0875 8.84263 12.0873L8.93264 11.4473L8.93264 11.4473L8.93289 11.4454C9.06042 10.5068 9.18751 9.60099 9.57694 8.87322C9.94668 8.18225 10.5648 7.63373 11.7551 7.44745L12.0933 7.39453V7.05225V6.97208C12.0933 6.85134 12.1651 6.71552 12.3413 6.59096C12.5187 6.46562 12.7396 6.4 12.8959 6.4C13.0557 6.4 13.2087 6.43617 13.3445 6.51083L13.5359 6.16282L13.3445 6.51083C13.482 6.58648 13.5993 6.69566 13.6828 6.82347L13.6831 6.82419C13.6876 6.83272 13.6934 6.84415 13.6992 6.85624C13.7045 6.86713 13.7086 6.8762 13.7113 6.88278L13.7119 6.8848C13.7123 6.88726 13.7135 6.89383 13.715 6.90556C13.7177 6.92593 13.7202 6.95098 13.7224 6.97719C13.7246 7.0029 13.7263 7.0271 13.7274 7.04499L13.7287 7.06577L13.729 7.07105L13.729 7.07218L13.729 7.07223L13.729 7.07226L13.729 7.07229L13.729 7.07232L13.729 7.07234L13.7453 7.3982L14.0679 7.44764C15.2548 7.62953 15.8693 8.16948 16.2355 8.84813C16.6215 9.56354 16.7463 10.456 16.8687 11.3837L16.8686 11.3837L16.8693 11.388L16.9695 12.0895L16.9696 12.0904C16.9734 12.1167 16.9773 12.1432 16.9811 12.1698C17.0676 12.767 17.1675 13.4561 17.3414 14.098C17.5213 14.7621 17.7933 15.4275 18.2577 15.9059C18.3383 15.9938 18.3927 16.0979 18.4171 16.2141C18.4398 16.3217 18.4291 16.4265 18.3829 16.5305L18.379 16.5391L18.3756 16.5479C18.3422 16.6339 18.275 16.7159 18.161 16.7942ZM13.7135 6.88806C13.7141 6.88959 13.7143 6.89032 13.7143 6.8903C13.7143 6.89028 13.714 6.88951 13.7135 6.88806Z",
    fill: "url(#paint0_linear_5040_5436)",
    stroke: "url(#paint1_linear_5040_5436)",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.1112 19.3467L12.0052 19.2683H12.0005C11.8069 19.1022 11.6545 18.8753 11.5728 18.624L11.4681 18.2945H14.3532L14.2481 18.6253L14.248 18.6252L14.2458 18.6327C14.1849 18.8382 14.0697 19.0309 13.9156 19.1851C13.7582 19.3424 13.5709 19.4592 13.3604 19.5294C13.2219 19.5755 13.0743 19.599 12.9257 19.599C12.8629 19.599 12.7964 19.5922 12.7058 19.5822C12.4836 19.5496 12.2797 19.4712 12.1112 19.3467Z",
    fill: "url(#paint2_linear_5040_5436)",
    stroke: "url(#paint3_linear_5040_5436)",
    strokeWidth: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5040_5436",
    x1: 7,
    y1: 11.6471,
    x2: 18.8286,
    y2: 11.6471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E50019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FF5A6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50019",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5040_5436",
    x1: 7,
    y1: 11.6471,
    x2: 18.8286,
    y2: 11.6471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E50019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FF5A6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50019",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5040_5436",
    x1: 10.9214,
    y1: 18.9468,
    x2: 14.8999,
    y2: 18.9468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E50019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FF5A6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50019",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5040_5436",
    x1: 10.9214,
    y1: 18.9468,
    x2: 14.8999,
    y2: 18.9468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E50019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FF5A6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50019",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifOrder);
export default __webpack_public_path__ + "static/media/notif-order.f207376b.svg";
export { ForwardRef as ReactComponent };